export default {"src":"/_next/static/media/result_is_empty.76f6e543.svg","height":133,"width":146};